import { render } from "./upButton_simple.vue?vue&type=template&id=7777e716&scoped=true"
import script from "./upButton_simple.vue?vue&type=script&lang=js"
export * from "./upButton_simple.vue?vue&type=script&lang=js"

import "./upButton_simple.vue?vue&type=style&index=0&id=7777e716&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7777e716"]])

export default __exports__